<template>
	<div class="component-container">
		<div :class="[{'shown': visibleScroller}, 'scroller']">
			<a href="#" class="" @click.prevent="$refs.addExtKey.scrollIntoView({ behavior: 'smooth' })"><span>⇑</span></a>
			<a href="#" class="" @click.prevent="$refs.SaveBtn.scrollIntoView({ behavior: 'smooth' })"><span>⇓</span></a>
		</div>
		<div class="heading">
			<h4 style="padding:0 15px">
				Translations on page:
				&nbsp;<select
					v-model="currentPage"
					@change="goToPage(currentPage)"
					class="small-selector">
					<option
						:key="page.Id"
						v-for="page in pages"
						:value="page.Id"
						:selected="$route.params.id.toString() == page.Id">{{ page.Name }}</option>
				</select>
			</h4>
			<button
				type="button"
				@click.prevent="scanPage"
				class="btn btn-green">
				<font-awesome-icon :icon="['fas', 'binoculars']"></font-awesome-icon> Scan Page
			</button>
			<form @submit.prevent="addExtKey(newExtKeyQuery)">
				<input type="text" ref="addExtKey" class="search-input" v-model="newExtKeyQuery" placeholder="Add External Key">
				<input type="submit" class="btn btn-green" value="Add">&nbsp;
				<a href
					@click.prevent="scrollToExtKeys"
					v-if="extKeys.length && !isInViewport('ExternalKeysRow')"
					style="text-decoration:none;"><font-awesome-icon
						:icon="['fas', 'angle-double-down']" style="color:#ccc"></font-awesome-icon></a>&nbsp;&nbsp;
			</form>
			<a v-show="!filterKeyQuery.length" href @click.prevent="importingKeys = true" v-if="!importingKeys"><small>import external keys</small></a>
			<form v-if="importingKeys" @submit.prevent="importExternalKeys(keyImportPage)" style="margin-top:-16px;font-size:86.5%;">
				<label for="keyImportPage" style="color:#ddd;"><small>Import external keys from page</small></label><br>
				<select
					id="keyImportPage"
					ref="keyImportPage"
					v-model="keyImportPage"
					class="small-selector">
					<option value="">select page</option>
					<option
						:key="p.Id"
						v-for="p in pages"
						:value="p.Name">
						{{p.Name}}
					</option>
				</select>&nbsp;
				<button type="submit" class="btn btn-green">import</button>&nbsp;
				<button
					type="reset"
					@click.prevent="importingKeys = false"
					style="border: none; border-radius: 3px; padding: 3px; margin-top: 1px;">cancel</button>
			</form>
			<div style="display:flex;flex-grow:1;flex-direction: row-reverse;">
				<a href
					v-if="!isInViewport('SaveBtn')"
					@click.prevent="$refs.SaveBtn.scrollIntoView({ behavior: 'smooth' })"
					style="margin:0 15px">
					<font-awesome-icon
						:icon="['far', 'save']" style="color:#ccc"></font-awesome-icon> <small> go to save</small>
				</a>
			</div>
		</div>
		<div :class="['content translation-page', {'loading': storeLoading || localLoading}]" ref="content">
			<table class="list" cellpadding="0" cellspacing="0" width="100%">
				<thead class="list-heading">
					<tr>
						<th width="50%">
							<p style="position:relative;">Translation keys
								<input
									type="text"
									class="search-input keys-filter pull-left"
									:class="{active: filterKeyQuery}"
									placeholder="filter key"
									v-model="filterKeyQuery">
								<font-awesome-icon
									v-if="filterKeyQuery"
									@click.prevent="filterKeyQuery = ''"
									:icon="['fas', 'times']"
									style="position: relative;top: 3px;right: 20px;cursor:pointer;padding: 3px 5px;"></font-awesome-icon>
							</p>
						</th>
						<th width="50%">
							<p v-show="!filterKeyQuery.length">
								Translation in &nbsp;
								<select
									v-model="language"
									@change="changedLang"
									class="form-control"
									style="border:1px solid #555;padding:3px 5px;background-color:transparent;color:#ccc;">
									<option
										:key="lang.Id"
										v-for="lang in languages"
										:value="lang.Code">{{lang.Name}}</option>
								</select>
								<span style="display:block;float:right;margin:0 15px;">
									<a href
										v-if="!importing"
										@click.prevent="importing = true"
										type="button">import translations</a>
									<form
										v-if="importing"
										@submit.prevent="importTranslations(importingPage)">
										<select
											ref="importingPage"
											v-model="importingPage"
											@change="$refs.importingPage.classList.remove('error')"
											class="small-selector">
											<option value="">select page</option>
											<option
												:key="p.Id"
												v-for="p in pages"
												:value="p.Name">
												{{p.Name}}
											</option>
										</select> &nbsp;
										<button type="submit" class="btn btn-green">import</button>&nbsp;
										<button
											type="reset"
											@click.prevent="importing = false;importingPage = '';"
											style="border:none;border-radius:3px;padding:3px;margin-top:1px;">cancel</button>
									</form>
								</span>
							</p>
						</th>
					</tr>
				</thead>
				<tr v-if="keys.length" class="tr-sep">
					<td colspan="2" align="center" style="font-size:18px;"><strong>Template Keys</strong></td>
				</tr>
				<tr v-for="(item, i) in keys"
				:key="'tr' + i"
				class="list-item">
					<td class="list-item-grow" @click.prevent="goToTranslation('tr', i)">
						<p style="font-size:15px;">{{item}}</p>
					</td>
					<td class="list-item-grow list-item-action1 translation">
						<label class="col-xs-12">
							<input
								:key="`translation-${language}-${formatTranslationKeys(item)}`"
								type="text"
								:ref="`tr`+i"
								v-model="loctranslations[formatTranslationKeys(item)]"
								v-ai-translate="{
									phrase: item,
									targetLanguage: selectedLanguage?.Name,
									targetLanguageCode: selectedLanguage?.Code,
									onTranslated: handleTranslation
								}"
								class="translation-inp"
								style="width:calc(100% - 10px);padding-left:5px;padding-right:5px;font-size:15px;">
						</label>
					</td>
				</tr>
				<tr v-if="extKeys.length" class="tr-sep ext" style="">
					<td colspan="2" align="center" style="font-size:18px;">
						<strong ref="ExternalKeysRow">External Keys</strong>
					</td>
				</tr>
				<tr v-for="(item, i) in extKeys"
				:key="'etr' + i"
				class="list-item list-extkeys">
					<td class="list-item-grow" @click.prevent="goToTranslation('etr', i)">
						<p style="font-size:15px;">
							{{item}} <font-awesome-icon
								@click="removeExtKey(i)"
								:icon="['fas', 'times']"></font-awesome-icon>
						</p>
					</td>
					<td class="list-item-grow list-item-action1 translation">
						<label class="col-xs-12">
							<input
								:key="`translation-${language}-${formatTranslationKeys(item)}`"
								type="text"
								:ref="`etr`+i"
								v-model="locexttranslations[formatTranslationKeys(item)]"
								v-ai-translate="{
									phrase: item,
									targetLanguage: selectedLanguage?.Name,
									targetLanguageCode: selectedLanguage?.Code,
									onTranslated: handleTranslation
								}"
								class="translation-inp"
								style="width:calc(100% - 10px);padding-left:5px;padding-right:5px;font-size:15px;">
						</label>
					</td>
				</tr>
				<tr v-if="!keys.length && !extKeys.length" class="tr-sep">
					<td colspan="2" align="center" style="font-size:18px;"><strong><span>No Keys</span> <span v-if="filterKeyQuery"> With Current Filter</span></strong></td>
				</tr>
				<tr v-if="!filterKeyQuery" class="tr-sep" style="background:#19191f">
					<td align="left">
						<p>Total keys for translation: {{ totalKeys }}</p>
					</td>
					<td align="right" style="padding-right:15px;">
						<p :title="`translated ${localKeysTranslatedCount} out of ${totalKeys}`">
							Translated: {{ translatedPercentage }}% <small>({{localKeysTranslatedCount + '/' + totalKeys}})</small>
						</p>
					</td>
				</tr>
				<tr>
					<td colspan="2" align="center" cellpadding="0" style="padding:0">
						<button v-show="!filterKeyQuery.length"
							type="button"
							ref="SaveBtn"
							@click.prevent="save"
							class="btn btn-green col-xs-12 save-btn">SAVE</button>
					</td>
				</tr>
			</table>
			<transition name="fade" mode="out-in">
				<div v-if="activeModal" @click.self="activeModal = false" class="full-screen-wrapper">
					<Modal @modalResponse="modalResponse" :note="note" :message="message"></Modal>
				</div>
			</transition>
		</div>
	</div>
</template>
<script>
import Modal from '../components/Modal.vue'
import Utils from '@/mixins/utils'

export default {
	components: {
		Modal
	},
	mixins: [ Utils ],
	data () {
		return {
			currentPage: this.$route.params.id.toString(),
			filterKeyQuery: '',
			newExtKeyQuery: '',
			language: '',
			importing: false,
			importingPage: '',
			loctranslations: {},
			locexttranslations: {},
			locExtKeys: [],
			importingKeys: false,
			keyImportPage: '',
			activeModal: false,
			message: '',
			note: '',
			visibleScroller: false,
			localLoading: true
		}
	},
	computed: {
		page () {
			return this.$store.getters['Pages/getPage']
		},
		pages () {
			return this.$store.getters['Pages/getPages']
		},
		languages () {
			return this.$store.getters.getLanguages
		},
		selectedLanguage () {
			return this.languages.find((l) => {
				return l.Code === this.language
			})
		},
		translations () {
			const trs = this.$store.getters.getTranslations
			const result = {}
			for (let k in this.keys) {
				result[this.formatTranslationKeys(this.keys[k])] = trs[this.formatTranslationKeys(this.keys[k])]
			}
			return result
		},
		exttranslations () {
			const trs = this.$store.getters.getExtTranslations
			const result = {}
			for (let k in this.extKeys) {
				result[this.formatTranslationKeys(this.extKeys[k])] = trs[this.formatTranslationKeys(this.extKeys[k])]
			}
			return result
		},
		translationsPerPage () {
			return this.$store.getters.getTranslationsPerPage
		},
		keys () {
			if (this.filterKeyQuery) {
				return this.$store.getters.getTranslationKeys.filter((k) => {
					return k.toLowerCase().includes(this.filterKeyQuery.toLowerCase())
				})
			}
			return this.$store.getters.getTranslationKeys.length ? this.$store.getters.getTranslationKeys : []
		},
		extKeys () {
			if (this.filterKeyQuery && this.$store.getters.getExternalTranslationKeys.length) {
				return this.$store.getters.getExternalTranslationKeys.filter((k) => {
					return k.toLowerCase().includes(this.filterKeyQuery.toLowerCase())
				})
			}
			const defaultExtKeys = this.locExtKeys || []
			return this.$store.getters.getExternalTranslationKeys.length ? this.$store.getters.getExternalTranslationKeys : defaultExtKeys
		},
		formattedKeys () {
			return this.keys.map(k => this.formatTranslationKeys(k))
		},
		formattedExtKeys () {
			return this.extKeys.map(k => this.formatTranslationKeys(k))
		},
		totalKeys () {
			const nr1 = parseInt(this.keys.length + this.extKeys.length)
			const nr2 = parseInt(Object.keys(this.loctranslations).length + Object.keys(this.locexttranslations).length)
			const nr = nr1 !== nr2 ? Math.max(nr1, nr2) : nr1
			return isNaN(nr) ? 0 : nr
		},
		localKeysTranslatedCount () {
			const translatedCount = this.loctranslations ? Object.values(this.loctranslations).filter((t) => {
				return t !== undefined && t.length > 0
			}).length : 0
			const extTranslatedCount = this.locexttranslations ? Object.values(this.locexttranslations).filter((t) => {
				return t !== undefined && t.length > 0
			}).length : 0
			return (translatedCount + extTranslatedCount)
		},
		translatedPercentage () {
			if (this.totalKeys === 0) {
				return 0
			}
			const nr = Math.round(this.localKeysTranslatedCount * 100 / this.totalKeys)
			if (!isFinite(nr)) {
				return 0
			}
			return isNaN(nr) ? 0 : nr
		},
		storeLoading () {
			return this.$store.getters.isLoading
		}
	},
	methods: {
		async preMount () {
			this.localLoading = true
			this.$store.dispatch('Pages/loadPage', this.$route.params.id.toString())
			await this.$store.dispatch('getLanguages')
			// leave language as is (for watcher page change) or default to 1st language
			this.language = this.language || this.languages[0].Code
			await this.$store.dispatch('getTranslationKeys', this.page.Name)
			await this.$store.dispatch('getExternalTranslationKeys', this.page.Name)
			await this.$store.dispatch('getTranslations', { page: this.page.Name, lang: this.language })
			this.loctranslations = this.translations
			// this.loctranslations = this.translationsPerPage[this.page.Name]
			this.locexttranslations = this.exttranslations
			this.localLoading = false
		},
		goToTranslation (str, i) {
			this.$refs[`${str}${i}`][0].focus()
		},
		addExtKey (k) {
			// if no ext keys yet
			if (!this.extKeys.length) {
				this.$set(this.extKeys, 0, k)
				this.locexttranslations[this.formatTranslationKeys(k)] = ''
				this.newExtKeyQuery = ''
				this.locExtKeys = this.extKeys
				setTimeout(() => {
					this.goToTranslation('etr', this.extKeys.length - 1)
				}, 100)
				return
			}
			// if key already added
			if (this.extKeys.includes(k)) {
				// console.error('Key already exists')
				this.$store.commit('Toast/_addError', 'Key already exists')
				this.filterKeyQuery = k
				this.newExtKeyQuery = ''
				return
			}
			// add new key and empty translation, then clear adding-key input and focus on translation input
			this.extKeys.push(k)
			// this.exttranslations.push('')
			this.locexttranslations[this.formatTranslationKeys(k)] = ''
			this.newExtKeyQuery = ''
			setTimeout(() => {
				this.goToTranslation('etr', this.extKeys.length - 1)
			}, 100)
		},
		removeExtKey (i) {
			const item = this.extKeys[i]
			this.activeModal = true
			this.note = item
			this.message = `Delete ${item} key?`
		},
		modalResponse (value) {
			if (value.resp) {
				const idx = this.extKeys.indexOf(this.note)
				this.locExtKeys.splice(idx, 1)
				delete this.locexttranslations[this.formatTranslationKeys(this.note)]
				this.$store.dispatch('removeExternalKey', this.note)
				this.activeModal = false
			} else {
				this.activeModal = false
				this.note = ''
			}
		},
		saveTranslations () {
			const obj = {
				page: this.page.Name,
				lang: this.language,
				data: {}
			}
			let fkey
			this.keys.forEach((k) => {
				fkey = this.formatTranslationKeys(k)
				obj.data[fkey] = this.loctranslations[fkey] ? this.loctranslations[fkey] : ''
			})
			this.extKeys.forEach((k) => {
				fkey = this.formatTranslationKeys(k)
				obj.data[fkey] = this.locexttranslations[fkey] ? this.locexttranslations[fkey] : ''
			})
			this.$store.dispatch('saveTranslations', obj)
		},
		saveExternalKeys () {
			const obj = {
				page: this.page.Name,
				Keys: []
			}
			obj.Keys = obj.Keys.concat(this.extKeys)
			this.$store.dispatch('saveExternalKeys', obj)
		},
		save () {
			// reset ui filter key, then save
			this.filterKeyQuery = ''
			this.saveTranslations()
			this.saveExternalKeys()
		},
		async scanPage () {
			// scan page
			await this.$store.dispatch('scanPage', this.page.Name)
			setTimeout(async () => {
				// refresh keys
				await this.$store.dispatch('getTranslationKeys', this.page.Name)
			}, 1000)
		},
		async importTranslations (page) {
			if (!page) {
				this.$refs['importingPage'].classList.add('error')
				return
			}
			await this.$store.dispatch('getTranslations', { page: page, lang: this.language })
			// let fkey
			// const formattedKeys = this.keys.map(k => this.formatTranslationKeys(k))
			// const formattedExtKeys = this.extKeys.map(k => this.formatTranslationKeys(k))
			for (let fkey of Object.keys(this.translationsPerPage[page])) {
				if (this.formattedKeys.includes(fkey)) {
					// if imported translation exists for this key, but no translation is set in current page
					if (this.translationsPerPage[page][fkey] && !this.loctranslations[fkey]) {
						this.loctranslations[fkey] = this.translationsPerPage[page][fkey]
					}
				}
				if (this.formattedExtKeys.includes(fkey)) {
					// if imported translation exists for this extkey, but no translation is set in current page
					if (this.translationsPerPage[page][fkey] && !this.locexttranslations[fkey]) {
						this.locexttranslations[fkey] = this.translationsPerPage[page][fkey]
					}
				}
			}
			// this.loctranslations = this.translations
			// this.locexttranslations = this.exttranslations
			this.importingPage = ''
			this.importing = false
		},
		scrollToExtKeys () {
			this.$refs.ExternalKeysRow.scrollIntoView({ behavior: 'smooth' })
		},
		isInViewport (elem) {
			if (!this.$refs[elem]) {
				return false
			}
			var bounding = this.$refs[elem].getBoundingClientRect()
			return (
				bounding.top >= 0 &&
				bounding.left >= 0 &&
				bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
				bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
			)
		},
		async importExternalKeys () {
			if (!this.keyImportPage) {
				this.$refs.keyImportPage.classList.add('error')
				return
			}
			await this.$store.dispatch('importExternalKeys', { page: this.keyImportPage })
				.then((res) => {
					// this.locexttranslations = []
					this.keyImportPage = ''
					this.importingKeys = false
				})
		},
		async changedLang () {
			await this.$store.dispatch('getTranslations', { page: this.page.Name, lang: this.language })
			this.loctranslations = this.translations
			this.locexttranslations = this.exttranslations
		},
		goToPage (page) {
			// replace page id in url and let the watcher do the refresh
			this.$router.replace({ name: 'page-translation', params: { id: this.currentPage } })
		},
		handleTranslation (translatedText, originalText) {
			// Optional: Add any custom logic here when translation is completed
			// For example, you could show a success message, log the translation, etc.
			// console.log('Translation completed:', { originalText, translatedText })

			// You could also trigger a toast notification
			// this.$store.commit('toast/_addSuccess', 'Translation completed successfully', { root: true })
		}
	},
	beforeCreate () {
	},
	created () {
		this.keyImportPage = ''
	},
	mounted () {
		const state = this
		window.addEventListener('scroll', () => {
			const visibleCondition = window.pageYOffset > 250 && window.pageYOffset <= document.documentElement.scrollHeight - window.outerHeight - 150
			if (visibleCondition) {
				state.visibleScroller = true
			} else {
				state.visibleScroller = false
			}
		})
	},
	async beforeMount () {
		await this.preMount()
	},
	watch: {
		$route (to, from) {
			if (to !== from) {
				this.preMount()
			}
		}
	}
}
</script>
<style lang="scss" scoped>
.content.loading:before {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(0,0,0,0.8);
    z-index: 1;
}
.content.loading:after {
    content: "please wait...";
    display: block;
    position: fixed;
    top: 0;
    width: auto;
    text-align: center;
    margin: 44vh 43vw;
    color: #737373;
    font-size: 30px;
    height: 20px;
    z-index: 2;
}
select.small-selector {
	width: 100px;
	border-radius: 3px;
	height: 22px;
	// background-color:var(--secondary-background-color);
	// color:var(--primary-text-color);
	// option {
	// 	background:var(--secondary-background-color);
	// }
}
table td.translation {
	padding:0;
}
.translation-inp {
	border:none;
	background-color:transparent;
	color:#ccc;
	height:38px;
	width:100%;
}
.tr-sep {
	background-image:repeating-linear-gradient(45deg, #303030, #303030 10px, #272727 10px, #272727 20px);
	&.ext {
		background-image:repeating-linear-gradient(135deg, #303030, #303030 10px, #272727 10px, #272727 20px);
	}
	td {
		color:#ccc;
		font-size:13px;
		text-transform: uppercase;
		border-top:1px solid #333;
		padding-top:5px;
		padding-bottom:5px;
	}
}
tr.list-item {
	background-image: repeating-linear-gradient(45deg, #3030301a, #3030301a 10px, #2727271a 10px, #2727271a 20px);
	&.list-extkeys {
		background-image: repeating-linear-gradient(135deg, #3030301a, #3030301a 10px, #2727271a 10px, #2727271a 20px);
	}
}
.save-btn {
	width: 30%;
    margin: 20px 0;
    font-size: 15px;
    font-weight: 600;
    padding: 6px 0;
    height: 30px;
}
.list-extkeys {
	p {
		position:relative;
		padding-right: 20px;
		svg {
			position:absolute;
			top:0;
			right:5px;
			margin-top:-2px;
			padding:5px;
			color:lighten(red, 25%);
			cursor:pointer;
			&:hover {
				color:red;
			}
		}
	}
}
input.error, select.error, textarea.error {
	border-color:red;
}
.keys-filter {
	padding: 3px 6px;
	&.active {
		background-color: #b49b48;
		color: #fff;
	}
}
.scroller {
	position:fixed;
	top:auto;
	bottom:0;
	right:0;
	margin-right:15px;
	margin-bottom:calc(50vh - 40px);
	transition:transform .3s ease-out;
	transform: translate(105px);

	&.shown {
		transform: translate(65px);
	}

	&:hover {
		transform: translate(50px);
	}

	a {
		font-size:125%;
		text-decoration: none;
		padding:5px 60px 5px 10px;
		background-color:rgba(255,255,255,0.05);
		display: block;
		&:first-child {
			border-bottom:1px solid rgba(255,255,255,0.3);
		}
		&:hover {
			background-color:rgba(0,0,0,0.7);
			// background-color:rgba(255,255,255,0.8);
		}
		span {
			display: inline-block;
			vertical-align: middle;
		}
	}
}
</style>
